function getUrlKey(name){//获取url 参数
    return decodeURIComponent(
        (new RegExp('[?|&]'+name+'='+'([^&;]+?)(&|#|;|$)').exec(location.href)||[,""])[1].replace(/\+/g,'%20'))||null;
}

//配置接口权限
function configapi() {
    var screte="mVSGKrLIRMwcGtHH";
    var dateStr=this.getNowDate();
    var apiSign=this.$Md5(screte+dateStr).toUpperCase();
    this.$Axios({
      method: "post",
      url: "http://togzs.gzhcxt.com/api/h5/get-sdksignature",
      data: {
        接口签名: apiSign,
        访问URL: window.location.href.split("#")[0],
      },
    })
    .then((res) => {
      if (res.data.data) {
        var dataArr = res.data.data.split(";");
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: dataArr[0], // 必填，公众号的唯一标识
          timestamp: dataArr[1], // 必填，生成签名的时间戳
          nonceStr: dataArr[2], // 必填，生成签名的随机串
          signature: dataArr[3], // 必填，签名，见附录1
          jsApiList: ["chooseImage", "uploadImage", "getLocalImgData"],
        });
      }
    });
  }

export default {
    getUrlKey,
    configapi
}


// WEBPACK FOOTER //
// ./src/assets/js/commonFun.js